import { Box } from "@mui/material"
import React from "react"
import { CardScrim } from "../CallChrome/CardScrim"

interface VideoAndMicAccessModalProps {
  open: boolean
}

export const VideoAndMicAccessModal: React.FC<VideoAndMicAccessModalProps> = ({
  open,
}) => {
  if (!open) return null

  return (
    <CardScrim>
      <Box
        sx={{
          maxWidth: "588px",
          fontFamily: "var(--app-font-family, figtree, sans-serif)",
          fontSize: {
            xs: "var(--global-heading-s-medium-font-size)",
            sm: "var(--global-heading-l-medium-font-size)",
          },
          fontWeight: "var(--global-heading-l-medium-font-weight)",
          lineHeight: 1.33,
          color: "var(--color-text-text-white)",
        }}
      >
        To bring your avatar to life,
        <br />
        please allow access to your camera and microphone.
      </Box>
    </CardScrim>
  )
}
